import { Box, Button, Grid, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import moment from 'moment'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function MarketCard({ result = [] }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [viewData, setViewData] = useState({})
  useEffect(() => {
    if (result.length > 0) {
      setViewData(result[0])
    }
  }, [result])
  const handelbutton = (type) => {
    setViewData(result.find((r) => r.type === type))
  }
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500, alignItems: '' }}>
          <Box sx={{ height: 25, width: 25, mr: 1, overflow: 'hidden' }}>
            <img src="/images/download.svg" alt="" />
          </Box>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.markeet.market.title')}</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ color: 'gray' }}>{viewData?.title}</Box>
        </Box>
      </Box>
      <Box
        mt={1}
        height={'100%'}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {viewData?.type === 'market_financier' && (
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <TableContainer sx={{ color: 'white', maxHeight: 316 }}>
              <Table sx={{}}>
                <TableBody
                  sx={{
                    'td,th': { color: 'white', border: 'none', padding: '3px 0px' },
                    td: { paddingLeft: 4, whiteSpace: 'nowrap' },
                    '&:last-child td': { paddingRight: 2 },
                    '.MuiTableCell-root': { fontSize: 15 },
                  }}
                >
                  {viewData?.data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        <Box
                          component={'span'}
                          sx={{
                            borderLeft: `5px solid ${
                              (item.variation_1d || 0) >= 0 ? 'green !important' : 'red !important'
                            }`,
                            mr: '8px',
                          }}
                        ></Box>
                        {item.name}
                      </TableCell>
                      <TableCell align="right">
                        {parseFloat(item.price).toFixed(2)}{' '}
                        <Box component={'span'}>{item.symbol}</Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          color:
                            (item.variation_1d || 0) >= 0 ? 'green !important' : 'red !important',
                        }}
                      >
                        {item.variation_1d ? parseFloat(item.variation_1d).toFixed(2) : 0}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {viewData?.type === 'market_obligation' && (
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <TableContainer sx={{ color: 'white', maxHeight: 316 }}>
              <Table sx={{}}>
                <TableBody
                  sx={{
                    'td,th': { color: 'white', border: 'none', padding: '3px 0px' },
                    td: { paddingLeft: 4, whiteSpace: 'nowrap' },
                    '&:last-child td': { paddingRight: 2 },
                    '.MuiTableCell-root': { fontSize: 15 },
                  }}
                >
                  {viewData?.data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        <Box
                          component={'span'}
                          sx={{
                            borderLeft: `5px solid ${
                              (item.variation_1_jour || 0) >= 0
                                ? 'green !important'
                                : 'red !important'
                            }`,
                            mr: '8px',
                          }}
                        ></Box>
                        {item.name}
                      </TableCell>
                      <TableCell align="right">
                        {parseFloat(item.price).toFixed(2)}{' '}
                        <Box component={'span'}>{item.symbol}</Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          color:
                            (item.variation_1_jour || 0) >= 0
                              ? 'green !important'
                              : 'red !important',
                        }}
                      >
                        {parseFloat(item.variation_1_jour).toFixed(2) || 0}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {viewData?.type === 'market_europeen' && (
          <>
            <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
              <TableContainer sx={{ color: 'white', maxHeight: 316 }}>
                <Table sx={{}}>
                  <TableBody
                    sx={{
                      'td,th': { color: 'white', border: 'none', padding: '3px 0px' },
                      td: { paddingLeft: 4, whiteSpace: 'nowrap' },
                      '&:last-child td': { paddingRight: 2 },
                      '.MuiTableCell-root': { fontSize: 15 },
                    }}
                  >
                    {viewData?.data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          <Box
                            component={'span'}
                            sx={{
                              borderLeft: `5px solid ${
                                (item.variation_1d || 0) >= 0
                                  ? 'green !important'
                                  : 'red !important'
                              }`,
                              mr: '8px',
                            }}
                          ></Box>
                          {item.name}
                        </TableCell>
                        <TableCell align="right">
                          {parseFloat(item.price).toFixed(2)}{' '}
                          <Box component={'span'}>{item.symbol}</Box>
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            color:
                              (item.variation_1d || 0) >= 0 ? 'green !important' : 'red !important',
                          }}
                        >
                          {parseFloat(item.variation_1d).toFixed(2) || 0}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* LAP-733 (GE022) */}
              <Box color={'gray'} mt={1}>
                {t('investments.markeet.market.allNews')}
              </Box>
              {viewData?.news.map((item, index) => (
                <Box display={'flex'} key={index}>
                  <Box mr={1} color={'gray'}>
                    {moment(item.published_at).fromNow()}
                  </Box>
                  <Box component={'span'}>{item.title}</Box>
                </Box>
              ))}
              {/* LAP-733 (GE022) */}
              <Box color={'gray'} mt={1} textAlign={'center'}>
                {t('investments.markeet.market.moreNews')}
              </Box>
            </Box>
          </>
        )}
        {viewData?.type === 'market_americain' && (
          <>
            <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
              <TableContainer sx={{ color: 'white', maxHeight: 316 }}>
                <Table sx={{}}>
                  <TableBody
                    sx={{
                      'td,th': { color: 'white', border: 'none', padding: '3px 0px' },
                      td: { paddingLeft: 4, whiteSpace: 'nowrap' },
                      '&:last-child td': { paddingRight: 2 },
                      '.MuiTableCell-root': { fontSize: 15 },
                    }}
                  >
                    {viewData?.data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          <Box
                            component={'span'}
                            sx={{
                              borderLeft: `5px solid ${
                                (item.variation_1d || 0) >= 0
                                  ? 'green !important'
                                  : 'red !important'
                              }`,
                              mr: '8px',
                            }}
                          ></Box>
                          {item.name}
                        </TableCell>
                        <TableCell align="right">
                          {parseFloat(item.price).toFixed(2)}{' '}
                          <Box component={'span'}>{item.symbol}</Box>
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            color:
                              (item.variation_1d || 0) >= 0 ? 'green !important' : 'red !important',
                          }}
                        >
                          {parseFloat(item.variation_1d).toFixed(2) || 0}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* LAP-733 (GE022) */}
              <Box color={'gray'} mt={1}>
                {t('investments.markeet.market.allNews')}
              </Box>
              {viewData?.news.map((item, index) => (
                <Box display={'flex'} key={index}>
                  <Box mr={1} color={'gray'}>
                    {moment(item.published_at).fromNow()}
                  </Box>
                  <Box component={'span'}>{item.title}</Box>
                </Box>
              ))}
              {/* LAP-733 (GE022) */}
              <Box color={'gray'} mt={1} textAlign={'center'}>
                {t('investments.markeet.market.moreNews')}
              </Box>
            </Box>
          </>
        )}
        {viewData?.type === 'market_etf' && (
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <TableContainer sx={{ color: 'white', maxHeight: 316 }}>
              <Table sx={{}}>
                <TableBody
                  sx={{
                    'td,th': { color: 'white', border: 'none', padding: '3px 0px' },
                    td: { paddingLeft: 4, whiteSpace: 'nowrap' },
                    '&:last-child td': { paddingRight: 2 },
                    '.MuiTableCell-root': { fontSize: 15 },
                  }}
                >
                  {viewData?.data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        <Box
                          component={'span'}
                          sx={{
                            borderLeft: `5px solid ${
                              (item.variation_1_jour || 0) >= 0
                                ? 'green !important'
                                : 'red !important'
                            }`,
                            mr: '8px',
                          }}
                        ></Box>
                        {item.name}
                      </TableCell>
                      <TableCell align="right">
                        {parseFloat(item.price).toFixed(2)}{' '}
                        <Box component={'span'}>{item.symbol}</Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          color:
                            (item.variation_1_jour || 0) >= 0
                              ? 'green !important'
                              : 'red !important',
                        }}
                      >
                        {parseFloat(item.variation_1_jour).toFixed(2) || 0}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {viewData?.button && (
          <Box sx={{}}>
            <Stack spacing={2} direction="row" sx={{ justifyContent: 'center' }}>
              <Button
                variant="text"
                sx={{ color: 'gray', paddingY: 0 }}
                endIcon={
                  <ArrowDropUpIcon
                    sx={{ fontSize: '2.5rem !important', transform: 'rotate(270deg)' }}
                  />
                }
                onClick={() => handelbutton(viewData?.button[0].type)}
              >
                {viewData?.button[0].name}
              </Button>
              <Button
                variant="text"
                sx={{ color: 'gray', paddingY: 0 }}
                startIcon={
                  <ArrowDropDownIcon
                    sx={{ fontSize: '2.5rem !important', transform: 'rotate(270deg)' }}
                  />
                }
                onClick={() => handelbutton(viewData?.button[1].type)}
              >
                {viewData?.button[1].name}
              </Button>
            </Stack>
          </Box>
        )}
      </Box>
    </Box>
  )
}
